"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollUserInteractionTypes = exports.PollUserInteractionType = exports.PollJokerSlug = exports.getQuestions = void 0;
/**
 * Returns all questions of the poll with type 'QUESTION'
 * @param poll
 */
function getQuestions(poll) {
    return poll.questions ?
        poll.questions.filter(function (p) { return p.question_type !== 'INLINE_COVER'; }) :
        [];
}
exports.getQuestions = getQuestions;
var PollJokerSlug;
(function (PollJokerSlug) {
    PollJokerSlug["audience"] = "audience";
    PollJokerSlug["addTenSeconds"] = "add_ten_seconds";
    PollJokerSlug["alternativeQuestion"] = "alternative_question";
    PollJokerSlug["fiftyFifty"] = "fifty_fifty";
    PollJokerSlug["skipQuestion"] = "skip_question";
})(PollJokerSlug = exports.PollJokerSlug || (exports.PollJokerSlug = {}));
var PollUserInteractionType;
(function (PollUserInteractionType) {
    PollUserInteractionType["INITIAL"] = "initial";
    PollUserInteractionType["COMPLETED"] = "completed";
})(PollUserInteractionType = exports.PollUserInteractionType || (exports.PollUserInteractionType = {}));
exports.PollUserInteractionTypes = Object.values(PollUserInteractionType);
